import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Table, Button } from 'react-bootstrap'
import * as Common from "../Common";
import { useNavigate } from 'react-router-dom';
import LoginHeader from '../Login_header';
import Menu from '../Menu';

function Master_id_type() {
    const sid = sessionStorage.getItem("sessionId");
    const [onceRun, setOnceRun] = useState(false);
    const [idTypeList, setIdTypeList] = useState([]);
    const navigate = useNavigate();
    const [userRight, setUserRight] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'IDTYPE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiIdtype, [sid, "listidtype"], result => {
                        setIdTypeList(JSON.parse(result));
                    })
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun]);

    const exportFile = () => {
        var obj = {
            right: 'IDTYPE'
        }
        Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>ID Type</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {
                            userRight.query === "1" ?
                                <>&nbsp;
                                    <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button>
                                </>
                                : null
                        }
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Table responsive striped>
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Description</th>
                                    <th>Expirable</th>
                                    <th>Active</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    idTypeList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.id_code}</td>
                                            <td>{item.id_desc}</td>
                                            <td>{item.id_expirable == 1 ? "Yes" : "No"}</td>
                                            <td>{item.id_active == 1 ? "Yes" : "No"}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Master_id_type